import React, { useEffect, useRef} from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import { focusRef } from '../shared/EventHelpers';


const EditTextArea = ({ value, setValue, onKeyDown, isInvalid, autoFocus, maxLength }) => {

    const inputRef = useRef();
    useEffect(() => {
        autoFocus && focusRef(inputRef);
        if (value === undefined || value === null) {
            setValue('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChange = (e) => {
        setValue(e.target.value);
    }

    return (
        <div className='crm-editable-field-wrapper'>
            <div className='text-area-wrapper'>
                <TextareaAutosize
                    ref={inputRef}
                    className={`text-input ${isInvalid ? 'invalid' : ''}`}
                    value={value ?? ''}
                    onKeyDown={onKeyDown}
                    onChange={(e) => onChange(e)}
                    minRows={2}
                    maxRows={8}
                />
                {maxLength && (
                    <div className='text-area-word-count'>
                        {value?.length ?? 0} av {maxLength}
                    </div>
                )}
            </div>
        </div>
    );
};

export default EditTextArea;
